import { gql } from '@apollo/client';

const TRANSACTION_PRICES_FRAGMENT = gql`
  fragment TransactionPricesFragment on PriceSetting {
    clientInPersonFee
    clientRONFee
    notaryGetInPerson
    notaryGetRON
  }
`;

export default TRANSACTION_PRICES_FRAGMENT;
